import connecting_station from '../assets/connection_station.png';
import interchange_station from '../assets/interchange_station.png';
import station from '../assets/station.png';
import terminal_station from '../assets/terminal_station.png';

export const railLegend = [
    {
        id: 1,
        name: 'KTM Seremban Line',
        description: '(KTM Batu Caves - Pulau Sebang Line)',
        color: '#0068B1'
    },
    {
        id: 2,
        name: 'KTM Port Klang Line',
        description: '(KTM Tanjung Malim - Pelabuhan Klang Line)',
        color: '#F12F25'
    },
    {
        id: 3,
        name: 'LRT Ampang Line',
        color: '#F48F1F'
    },
    {
        id: 4,
        name: 'LRT Sri Petaling Line',
        color: '#890E01'
    },
    {
        id: 5,
        name: 'LRT Kelana Jaya Line',
        color: '#EB1751'
    },
    {
        id: 6,
        name: 'ERL KLIA Ekspres Line',
        color: '#903A91'
    },
    {
        id: 7,
        name: 'ERL KLIA Transit Line',
        color: '#0BA2B0'
    },
    {
        id: 8,
        name: 'KL Monorail Line',
        color: '#8EC73B'
    },
    {
        id: 9,
        name: 'MRT Kajang Line',
        color: '#00853C'
    },
    {
        id: 10,
        name: 'KTM Skypark Line',
        color: '#A57542'
    },
    {
        id: 11,
        name: 'LRT Shah Alam Line',
        color: '#01A3E2'
    },
    {
        id: 12,
        name: 'MRT Putrajaya Line',
        color: '#FFD400'
    },
];

export const stations = [
    {
        name: 'Connecting Station',
        image: connecting_station,
    },
    {
        name: 'Interchange Station',
        image: interchange_station,
    },
    {
        name: 'Terminal Station',
        image: terminal_station,
    },
    {
        name: ' Station',
        image: station,
    },
];

